module.exports = __webpack_public_path__ + "img/logo-new.ef67fd36.jpg";